import _ from 'lodash';
import platformUtils from '../privates/platformUtils';
import * as mixins from '../mixins';
import * as members from '../privates/privateMembers';
import * as validation from '../privates/validations/validation';
import {extendCompSchema} from '../privates/validations/compSchemas';
import valueSanitzationAlgorithm from '../privates/utils/valueSanitzationAlgorithm';
import {runValidations, runValidationsAfterChange, runValidationsAndSyncAfterChange, runValidationsAndSync, hideValidityIndication, extendValueMethodToInputType} from '../privates/validationsService/validationsService';
import compInitializeService from '../privates/compInitializeService/compInitializeService';
import {extendGetValidatorByType, validators, addErrorToValidateDataAndKeepMessage, VALIDITY_KEYS} from '../privates/utils/valueValidation';
import validatableWithSyncInitialize from '../privates/compInitializeService/validatableWithSyncInitialize';
import {valueValidatableInitialize, valueValidatableClearance} from '../privates/compInitializeService/valueValidatableInitialize';
import {generateError, extendGenerateError, formatPlatformizedHttpError} from '../privates/validations/errors';
import uiClasses from '../ui';
import Element from '../ui/Element';
import Node from '../ui/Node';
import Button from '../ui/Button';
import FormElement from '../ui/FormElement';
import Background from '../ui/Background';
import BaseImage from '../ui/BaseImage';
import * as postMessage from '../privates/postMessage';
import reporter from '../privates/reporter';
import {setType} from '../privates/utils';
import * as Utils from '../ui/Utils';
import sdkMonitoring from '../privates/monitoring';
import backgroundMediaUtils from '../privates/utils/backgroundMediaUtils';
import videoUtils from '../privates/utils/videoUtils';
import imageUtils from '../privates/utils/imageUtils';
import vectorImageUtils from '../privates/utils/vectorImageUtils';
import {setAsyncFunctions} from '../privates/utils/asyncDecorator';
import {setStageUnfriendlyFunctions} from '../privates/utils/livePreview';

class ModuleStore {
    constructor() {
        this.store = {};
    }

    set(namespace, scopedNamespace, Module) {
        Module = sdkMonitoring.monitorNamespace(Module);
        const module = new Module();
        self[namespace] = module;
        self.wix[scopedNamespace] = module;
        this.store[namespace] = {Module, scopedNamespace};
    }

    get(namespace) {
        return this.store[namespace];
    }

    getNamespaces() {
        return _.keys(this.store);
    }
}


const moduleStore = new ModuleStore();

const module = {
    register (namespaceName, scopedNamespaceName, Module) {
        if (_.has(self, namespaceName)) {
            reporter.reportSdkError(generateError.error_namespace_already_exists({namespace: namespaceName}));
        } else {
            moduleStore.set(namespaceName, scopedNamespaceName, Module);
        }
    }
};

const mediaUtils = {backgroundMediaUtils, imageUtils, vectorImageUtils, videoUtils};
const monitoring = {monitorClass: sdkMonitoring.monitorClass};
const errors = {generateError, formatPlatformizedHttpError, extendGenerateError};

const validationsService = {
    valueSanitzationAlgorithm,
    runValidationsAfterChange,
    runValidations,
    runValidationsAndSync,
    runValidationsAndSyncAfterChange,
    hideValidityIndication,
    extendValueMethodToInputType,
    extendGetValidatorByType,
    validators,
    addErrorToValidateDataAndKeepMessage,
    VALIDITY_KEYS
};

const componentInitializeService = {
    extendComponentsInitialize: compInitializeService.extendComponentsInitialize,
    extendComponentsRemoval: compInitializeService.extendComponentsRemoval,
    validatableWithSyncInitialize,
    valueValidatableInitialize,
    valueValidatableClearance
};

const ui = {Background, Element, FormElement, Node, Button, BaseImage};

ui.register = (viewerType, sdkType, module, typeOverrideMetadata) => {
  if (typeOverrideMetadata) {
    if (!platformUtils.isExperimentOpen(typeOverrideMetadata.viewerExperimentKey) &&
      !platformUtils.isExperimentOpen(typeOverrideMetadata.editorExperimentKey)) {
      return false;
    }
    uiClasses.registerComponent(sdkType, module, true);
  } else if (!uiClasses.registerComponent(sdkType, module)) {
    reporter.reportSdkError(generateError.error_component_already_exists({ component: sdkType }));
    return false;
  }
  setType(viewerType, sdkType);
  return true;
};

ui.Utils = Utils;

const livePreview = {setStageUnfriendlyFunctions};

export {
    ui,
    postMessage,
    mixins,
    validation,
    validationsService,
    componentInitializeService,
    extendCompSchema,
    platformUtils,
    reporter,
    errors,
    monitoring,
    members,
    module,
    moduleStore,
    mediaUtils,
    setAsyncFunctions,
    livePreview
};
